import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Checkbox, Grid } from '@mui/material';
import { Card, Typography } from '@totalsoft/rocket-ui';

function PartnerFileBulkListItem({ partner, onCheckBoxChange, saving }) {
  const { t } = useTranslation();
  const { partnerId, partnerName, partnerCode, uniqueId, actDate, isSelected } = partner;

  return (
    <Card>
      <Grid container gap={3} flexWrap='nowrap'>
        <Grid item display='flex' alignItems='center'>
          <Checkbox checked={isSelected} onChange={onCheckBoxChange(partnerId)} disabled={saving} />
        </Grid>
        <Grid item container spacing={2} alignItems='center'>
          <Grid item container xs={12} sm={6}>
            <Grid item container xs={12} xl={6} gap={1}>
              <Typography emphasis='bold'>{t('BulkPartners.PartnerName')}: </Typography>
              <Typography>{partnerName}</Typography>
            </Grid>
            <Grid item container xs={12} xl={6} gap={1}>
              <Typography emphasis='bold'>{t('BulkPartners.PartnerCode')}: </Typography>
              <Typography>{partnerCode}</Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12} sm={6}>
            <Grid item container xs={12} xl={6} gap={1}>
              <Typography emphasis='bold'>{t('BulkPartners.UniqueId')}: </Typography>
              <Typography>{uniqueId}</Typography>
            </Grid>
            <Grid item container xs={12} xl={6} gap={1}>
              <Typography emphasis='bold'>{t('BulkPartners.NextReviewDate')}: </Typography>
              <Typography>{t('DATE', { date: actDate })}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

PartnerFileBulkListItem.propTypes = {
  partner: PropTypes.object.isRequired,
  onCheckBoxChange: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default PartnerFileBulkListItem;
